// نسخه نهایی OrderCard با فرمت تاریخ مخصوص عربی (زمان عمان)
import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";
import { CDN_BASE_URL } from "../../../config";
import { useTranslation } from "react-i18next";

const OrderCard = ({ order }) => {
  const [show, setShow] = useState(false);
  const { t, i18n } = useTranslation();

  const deliveryETA = () => {
    if (order.status !== "preparing" || !order.deliveryTime || !order.updatedAt)
      return null;

    const updated = new Date(order.updatedAt);
    const now = new Date();
    const elapsedMinutes = Math.floor((now - updated) / 60000);
    const remainingMinutes = order.deliveryTime - elapsedMinutes;

    return remainingMinutes > 0 ? remainingMinutes : 0;
  };

  const formatCurrency = (amount) => `${amount.toLocaleString()} ${t("rial")}`;

  const createdAt = new Date(order.createdAt);
  const dateStr =
    i18n.language === "ar"
      ? createdAt.toLocaleDateString("ar-OM", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
          timeZone: "Asia/Muscat",
        })
      : createdAt.toLocaleDateString("en-US", {
          weekday: "short",
          year: "numeric",
          month: "short",
          day: "numeric",
        });

  const timeStr =
    i18n.language === "ar"
      ? createdAt.toLocaleTimeString("ar-OM", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
          timeZone: "Asia/Muscat",
        })
      : createdAt.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });

  return (
    <div className="bg-white shadow p-3 rounded-[8px]">
      {show && (
        <div
          onClick={() => setShow(false)}
          className="bg-black/50 fixed bottom-0 left-0 w-full h-full z-40"
        ></div>
      )}
      <div
        className={`${
          show ? "translate-y-0" : "translate-y-full"
        } duration-300 fixed bottom-0 left-0 z-[55] bg-white w-full p-4 rounded-t-[16px] text-black`}
      >
        <div className="flex gap-2 items-center mb-4">
          <FaTimes onClick={() => setShow(false)} className="cursor-pointer" />
          {t("order_invoice")}
        </div>

        <div className="text-[14px] grid gap-2 border-b border-gray-300 py-3">
          {order.items.map((item) => (
            <span key={item.product} className="flex justify-between">
              <span>{item.name || item.product?.name}</span>
              <span className="font-bold">
                {formatCurrency(item.price * item.quantity)}
              </span>
            </span>
          ))}
        </div>

        <div className="text-[14px] grid gap-2 border-b border-gray-300 py-3">
          <span className="flex justify-between">
            <span className="text-[16px] font-bold">{t("order_subtotal")}</span>
            <span className="font-bold">{formatCurrency(order.total)}</span>
          </span>
          <span className="flex justify-between">
            <span>{t("order_delivery_cost")}</span>
            <span className="font-bold">
              {formatCurrency(order.deliveryCost)}
            </span>
          </span>
        </div>

        <div className="text-[14px] grid gap-2 py-3">
          <span className="flex justify-between">
            <span className="text-[16px] font-bold">{t("order_total")}</span>
            <span className="font-bold">
              {formatCurrency(order.finalAmount)}
            </span>
          </span>
        </div>
      </div>
      {order.status === "preparing" && deliveryETA() !== null && (
        <div className="bg-blue-100 text-blue-800 p-3 rounded my-3 text-center text-sm font-medium">
          {t("order_eta_message", { minutes: deliveryETA() })}
        </div>
      )}
      <div className="flex justify-between items-start">
        <span className="text-[14px] text-[#777]">
          <p>
            {dateStr} - {timeStr}
          </p>
          <p>{order.address?.title || t("order_delivery_to")}</p>
        </span>
        {order.status === "delivered" ? (
          <span className="bg-green-200 text-green-600 rounded-[4px] px-3 py-1 text-[14px]">
            {t("order_status_delivered")}
          </span>
        ) : order.status === "preparing" ? (
          <span className="bg-sky-200 text-sky-600 rounded-[4px] px-3 py-1 text-[14px]">
            {t("order_status_preparing")}
          </span>
        ) : (
          <span className="bg-yellow-200 text-yellow-600 rounded-[4px] px-3 py-1 text-[14px]">
            {t("order_status_pending")}
          </span>
        )}
      </div>

      <div className="flex gap-2 pt-5 overflow-x-auto">
        {order.items.map((item, index) => (
          <span
            key={index}
            style={{ boxShadow: "rgb(0 0 0 / 16%) 0px 0px 6px 0px inset" }}
            className="relative shadow-inner rounded-[4px] p-1"
          >
            <span className="bg-white text-[14px] shadow absolute right-2 top-0 w-5 h-5 rounded-full flex items-center justify-center translate-x-1/2 -translate-y-1/2">
              {item.quantity}
            </span>
            <img
              src={CDN_BASE_URL + item.product.img}
              className="w-16 h-16 object-cover rounded"
              alt="item"
            />
          </span>
        ))}
      </div>

      <div className="flex justify-end mt-2">
        <span className="font-bold">{formatCurrency(order.finalAmount)}</span>
      </div>

      <div>
        <button
          onClick={() => setShow(true)}
          className="bg-[--secondry] p-1 mt-2 rounded-[4px] w-full text-white"
        >
          {t("view_invoice")}
        </button>
      </div>
    </div>
  );
};

export default OrderCard;
